/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const UpdateMyNotificationSettingsBody = zod.object({
  showMessagePreviews: zod
    .boolean()
    .optional()
    .describe(
      'Opt IN to message text in out-of-app deliveries. Leaving it false keeps lock screens content-free and keeps message redaction meaningful.',
    ),
});

export type UpdateMyNotificationSettingsBody = zod.input<typeof UpdateMyNotificationSettingsBody>;
export type UpdateMyNotificationSettingsBodyOutput = zod.output<
  typeof UpdateMyNotificationSettingsBody
>;
